<!-- List.vue -->
<template>
	<div>
		<div class="common-header-wrap">
			<mt-header title="自提门店" class="common-header">
				<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
			</mt-header>
		</div>
		<div class="common-popup-content" id="my_map"></div>
	</div>
</template>

<script>
import { getChainList } from '../../../api/homegoodsdetail'
import { loadScript } from '../../../util/common'
import { convertPoint } from '../../../util/bmap'
export default {
  data () {
    return {
      myMap: false,
      goods_id: this.$route.query.goods_id
    }
  },

  props: ['list'],

  created () {},
  mounted () {
    let _this = this
    loadScript('bmap', '//api.map.baidu.com/api?ak=' + env.BMAP_AK_BRO + '&type=lite&v=1.0', function () {
      // 百度地图API功能
      let map = new BMap.Map('my_map') // 创建Map实例
      navigator.geolocation.getCurrentPosition(function (position) {
        convertPoint(position.coords.longitude, position.coords.latitude).then(result => {
          if (result.status == 0) {
            var point = new BMap.Point(result.result[0].x, result.result[0].y)
            map.centerAndZoom(point, 16)
          } else {

          }
        }).catch(error => {

        })
      }, function (error) {}, { enableHighAcuracy: true })

      _this.myMap = map
      getChainList({ goods_id: _this.goods_id }).then(res => {
        let chain_list = res.result.chain_list
        for (var i in chain_list) {
          _this.mapAddMarker(chain_list[i])
        }
      })
    })
  },
  methods: {
    mapAddMarker (info) {
      var point = new BMap.Point(info.chain_longitude, info.chain_latitude)
      var marker = new BMap.Marker(point) // 创建标注
      this.myMap.addOverlay(marker) // 将标注添加到地图中
    }
  }
}
</script>

<style lang="scss">

</style>
